import React from 'react'

const PythonSvg = (props) => {

    return (
        <>

            <svg className='mb-2' width={props.customSize} height={props.customSize} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-label="Python" role="img"
                    viewBox="0 0 512 512">

                    <g fill="#5a9fd4">

                        <path id="p" d="M254 64c-16 0-31 1-44 4-39 7-46 21-46 47v35h92v12H130c-27 0-50 16-58 46-8 35-8 57 0 93 7 28 23 47 49 47h32v-42c0-30 26-57 57-57h91c26 0 46-21 46-46v-88c0-24-21-43-46-47-15-3-32-4-47-4zm-50 28c10 0 17 8 17 18 0 9-7 17-17 17-9 0-17-8-17-17 0-10 8-18 17-18z" />

                    </g>

                    <use xlinkHref="#p" fill="#ffd43b" transform="rotate(180,256,255)" />

                </svg>
        </>
    )
}

export default PythonSvg